const capabilities = [
  {
    icon: 'ri-stack-line',
    title: 'Clean Architecture',
    description:
      'Systems designed with separation of concerns, modular boundaries, and testable layers that support long-term scalability and ease of maintenance.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Performance Optimisation',
    description:
      'Deep profiling, efficient resource management, and responsive design patterns that ensure consistently fast and fluid user experiences.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Stability & Reliability',
    description:
      'Rigorous quality assurance, defensive coding practices, and comprehensive testing that keep systems dependable under real-world conditions.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'User-Centred Design',
    description:
      'Every interface decision grounded in usability principles, accessibility standards, and thoughtful interaction design that puts people first.',
  },
];

export default function ApproachSection() {
  return (
    <section className="w-full bg-background-50 py-24 md:py-32 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block px-4 py-1.5 border border-foreground-300/40 rounded-full text-foreground-500 text-xs font-semibold tracking-widest uppercase mb-6">
            Engineering Approach
          </span>
          <h2 className="font-heading text-foreground-900 text-4xl md:text-5xl font-bold leading-tight">
            How we build
            <br />
            software that lasts.
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mt-5 max-w-xl mx-auto leading-relaxed">
            Our engineering philosophy is rooted in discipline, clarity, and a
            deep respect for the craft of software development.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {capabilities.map((cap) => (
            <div
              key={cap.title}
              className="group p-8 rounded-lg bg-background-100/70 border border-background-200/60 transition-colors duration-500"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100/80 text-secondary-700 mb-6">
                <i className={`${cap.icon} text-xl`} />
              </div>
              <h3 className="font-heading text-foreground-900 text-lg font-bold leading-snug">
                {cap.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed mt-3">
                {cap.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}